<template>
  <v-container class>
    <v-row>
      <v-col cols="12">
        <v-progress-linear v-show="loading" indeterminate color="primary"></v-progress-linear>
        <v-progress-linear v-show="!loading" style="opacity:0"></v-progress-linear>
      </v-col>
      <v-col cols="4">
        <v-card class="st-app">
          <v-card-title class="f-14">
            <v-row>
              <v-col>Level Security User</v-col>
              <v-col>
                <v-btn color="primary" class="float-right" small @click="addDialog">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-list rounded>
            <v-list-item-group v-model="selectedLevel" color="primary" class="sae child-link">
              <v-list-item v-for="(item, i) in levelAccess" :key="i">
                <v-list-item-icon class="mr-1"></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="capitalize" v-text="item.name"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon class="mr-1">
                  <v-btn
                    icon
                    @click="editItem(item)"
                    small
                    v-bind:class="[selectedLevel == i ? 'white--text' :'']"
                    class="z-top"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-list-item-icon>
                <v-list-item-icon class="mr-1">
                  <v-btn
                    icon
                    @click="deleteItem(item)"
                    small
                    v-bind:class="[selectedLevel == i ? 'white--text' :'']"
                    class="z-top"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="5">
        <v-card>
          <v-card-title class="f-14">Structure Organization</v-card-title>
          <v-divider></v-divider>
          <v-container>
            <div>
              <v-row class justify="space-between">
                <v-col>
                  <div class="scrollingtable st-app">
                    <v-treeview
                      :items="structureList"
                      activatable
                      color="primary"
                      transition
                      open-all
                      @update:active="handleClickStructure"
                      return-object
                      item-text="groupName"
                    >
                      <template v-slot:prepend="{ item }">
                        <div @click="handleClickStructureCheck(item)" style="cursor: pointer">
                          <v-icon
                            v-bind:class="{'white': item.isChecked, 'primary--text':item.isChecked}"
                          >{{detectPrependIcon(item)}}</v-icon>
                        </div>
                      </template>
                    </v-treeview>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="pa-0">
          <v-card-title class="f-14">Golongan/Grade</v-card-title>
          <v-divider></v-divider>
          <v-container>
            <!-- <div v-if="loading">
              <v-skeleton-loader
                type="list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
              ></v-skeleton-loader>
            </div>-->
            <v-row class justify="space-between">
              <v-col>
                <div class="scrollingtable st-app">
                  <v-treeview :items="gradeList" color="primary" transition>
                    <template v-slot:label="{ item }">
                      <div @click="handleClickGradeCheck(item)" style="cursor: pointer">
                        <v-icon
                          v-bind:class="{'white': item.subId, 'primary--text':item.subId}"
                        >{{detectPrependIcon(item)}}</v-icon>
                        <span class="pl-3">{{ item.className }}</span>
                      </div>
                    </template>
                  </v-treeview>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog overlay-opacity="0.7" v-model="dialog" max-width="550">
      <v-form v-model="valid" ref="form">
        <v-card>
          <v-card-title class="headline">{{isEdit ? 'Edit' :'Add'}} Level Security</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Name"
                  v-model="detail.name"
                  type="text"
                  :rules="rules"
                  required
                  class="sae-required"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Note" v-model="detail.note" type="text"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="saveOrUpdate(detail)"
              :loading="loading"
              :disabled="!valid"
            >Save</v-btn>
            <v-btn color="default" text @click="dialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete!</v-card-title>
        <v-card-text>Are you sure you would like to do this?</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteUserAccess(itemToDelete)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  name: "AccessControl",
  data() {
    return {
      companyId: this.$store.getters.pGetData('companyId'),
      dialog: false,
      deleteDialog: false,
      isEdit: false,
      valid: false,
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      detail: {},
      selectedStucture: [],
      selectedGrade: [],
      selectedLevel: null,
      loading: false,
      levelAccess: [],
      structureList: [],
      gradeList: []
    };
  },
  methods: {
    mappingGradelist(array = []) {
      let obj, list = [];
      for (let i = 0; i < array.length; i++) {
        obj = array[i];
        obj.subId = obj.id
        obj.id = i
        list.push(obj)
      }
      return list
    },
    mappingStructurelist(array = []) {
      let obj, ii, sae;
      for (let i = 0; i < array.length; i++) {
        obj = array[i];
        obj.subId = obj.id
        obj.id = i
        if (obj.parentId > 0) {
          for (ii = 0; ii < array.length; ii++) {
            sae = array[ii];
            if (sae.groupId == obj.parentId) {
              if (!sae.children) sae.children = [];
              sae.children.push(obj);
              break;
            }
          }
        }
      }

      let tempArray = [];
      for (let i = 0; i < array.length; i++) {
        obj = array[i];
        if (obj.parentId == 0) {
          tempArray.push(obj);
        }
      }
      return tempArray
    },
    detectPrependIcon(item) {
      return item.isChecked ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
    },
    handleClickStructureCheck(item) {
      if (item.subId != null) {
        this.deleteComponentOrganization(item)
      } else {
        this.saveComponentOrganization(item)
      }
    },
    async handleClickStructure(event) {
      if (event.length > 0) {
        const item = event[0]
        if (item) {
          if (item.subId != null) {
            this.selectedStucture = item.subId
            this.gradeList = await this.getGradeByStructure(item.subId)
          } else {
            this.selectedStucture = null
            this.gradeList = []
          }
        }
      }
    },
    handleClickGradeCheck(item) {
      if (item.subId != null) {
        this.deleteComponentGrade(item)
      } else {
        this.saveComponentGrade(item)
      }
    },
    addDialog() {
      this.isEdit = false
      this.detail = {}
      this.dialog = true
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    editItem(item) {
      this.detail = Object.assign({}, item)
      this.isEdit = true
      this.dialog = true
    },
    deleteItem(item) {
      this.itemToDelete = Object.assign({}, item);
      this.deleteDialog = true;
    },
    async getLevelAccess() {
      this.loading = true
      const result = await this.$store.dispatch('getLevelAccess', { companyId: this.companyId })
      this.loading = false
      return result
    },
    async getLevelAccessOrganizations(i) {
      this.loading = true
      const result = await this.$store.dispatch('getLevelAccessOrganization', { levelAccessId: this.levelAccess[i].id, companyId: this.companyId })
      this.loading = false
      return this.mappingStructurelist(result)
    },
    async getGradeByStructure(id) {
      this.loading = true
      const result = await this.$store.dispatch('getLevelAccessClasses', { levelAccessId: this.levelAccess[this.selectedLevel].id, orgAccessId: id, companyId: this.companyId })
      this.loading = false
      return this.mappingGradelist(result)
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data, companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('saveLevelAccess', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.levelAccess = await this.getLevelAccess()
      }
    },
    async editComponent(data) {
      const body = { ...data, companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('editLevelAccess', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.levelAccess = await this.getLevelAccess()
      }
    },
    async deleteUserAccess(data) {
      this.loading = true
      const result = await this.$store.dispatch('deleteLevelAccess', { id: data.id, companyId: this.companyId })
      this.loading = false
      if (result) {
        this.showMessage('success', 'Delete Success!')
        this.deleteDialog = false
        this.levelAccess = await this.getLevelAccess()
      }
    },
    async saveComponentOrganization(data) {
      const body = { groupsId: [data.groupId], levelId: this.levelAccess[this.selectedLevel].id, companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('saveLevelAccessOrganizations', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.structureList = await this.getLevelAccessOrganizations(this.selectedLevel)
      }
    },
    async deleteComponentOrganization(data) {
      this.loading = true
      const result = await this.$store.dispatch('deleteLevelAccessOrganizations', { id: data.subId, companyId: this.companyId })
      this.loading = false
      if (result) {
        this.showMessage('success', 'Delete Success!')
        this.deleteDialog = false
        this.structureList = await this.getLevelAccessOrganizations(this.selectedLevel)
        this.gradeList = []
      }
    },
    async saveComponentGrade(data) {
      const body = { levelId: this.levelAccess[this.selectedLevel].id, orgAccessId: this.selectedStucture, classesId: [data.classId], companyId: this.companyId }
      this.loading = true
      const result = await this.$store.dispatch('saveLevelAccessClasses', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.gradeList = await this.getGradeByStructure(this.selectedStucture)
      }
    },
    async deleteComponentGrade(data) {
      this.loading = true
      const result = await this.$store.dispatch('deleteLevelAccessClasses', { id: data.subId, companyId: this.companyId })
      this.loading = false
      if (result) {
        this.showMessage('success', 'Delete Success!')
        this.deleteDialog = false
        this.gradeList = await this.getGradeByStructure(this.selectedStucture)
      }
    },
  },
  async created() {
    this.levelAccess = await this.getLevelAccess()
    if (this.levelAccess.length > 0) {
      this.selectedLevel = 0
      this.structureList = await this.getLevelAccessOrganizations(0)
    }
  },
  computed: {
  },
  watch: {
    async selectedLevel(i) {
      if (i != null) {
        this.structureList = await this.getLevelAccessOrganizations(i)
        this.gradeList = []
      } else {
        this.structureList = []
      }
    }
  }
};
</script>
<style>
.jl-1 {
  margin-left: 0;
}
.jl-2 {
  margin-left: 1.2rem;
}
.jl-3 {
  margin-left: 2.4rem;
}
.jl-4 {
  margin-left: 3.6rem;
}
.jl-5 {
  margin-left: 4.8rem;
}
.jl-6 {
  margin-left: 6rem;
}
.z-top {
  z-index: 10 !important;
}
.no-box .v-input--selection-controls__input .v-icon,
.no-box .v-input--selection-controls__ripple {
  display: none !important;
  cursor: none !important;
}
.mml-3 {
  margin-left: -35px;
}
</style>